import React, { useEffect, useState, useRef } from "react";
import { createPortal } from "react-dom";
import { useNavigate, useLocation } from "react-router-dom";
// import rank1 from "../Assets/Charms/DC_Romance.gif";
// import rank2 from "../Assets/Charms/DC_Education.gif";
// import rank3 from "../Assets/Charms/DC_Health.gif";
// import rank4 from "../Assets/Charms/DC_Love.gif";
// import rank5 from "../Assets/Charms/DC_Wealth.gif";
// import rank6 from "../Assets/Charms/DC_Wisdom.gif";
// import rank7 from "../Assets/Charms/DC_Prosperity.gif";
// import rank8 from "../Assets/Charms/DC_Protection.gif";
// import rank9 from "../Assets/Charms/paid_charm_1.gif";
// import rank10 from "../Assets/Charms/paid_charm_2.gif";
// import rank11 from "../Assets/Charms/free_charm.gif";
import rank1 from "../Assets/Charms/paid_charm_2.gif";
import rank2 from "../Assets/Charms/paid_charm_2.gif";
import rank3 from "../Assets/Charms/paid_charm_2.gif";
import rank4 from "../Assets/Charms/paid_charm_2.gif";
import rank5 from "../Assets/Charms/paid_charm_2.gif";
import rank6 from "../Assets/Charms/paid_charm_2.gif";
import rank7 from "../Assets/Charms/paid_charm_2.gif";
import rank8 from "../Assets/Charms/paid_charm_2.gif";
import rank9 from "../Assets/Charms/paid_charm_2.gif";
// import rank10 from "../Assets/Charms/paid_charm_2.gif";
// import rank11 from "../Assets/Charms/free_charm.gif";
import testImage from "../Assets/amulet.png";
import calm from "../Assets/Others/calm.png";
import meditation from "../Assets/Others/meditation.png";
import touch from "../Assets/Others/touch.png";
import { useTranslation } from "react-i18next";
import {
  blessedAmulets,
  fortuneSticks,
  lifeForecast,
  selfMastery,
  natalArrow,
  natalTitleFooter,
} from "../Assets/Xianhe New Assets/natal-assets";

//const rankImages = [rank1, rank2, rank3, rank4, rank5, rank6, rank7, rank8, rank9, rank10, rank11];
const rankImages = [
  rank1,
  rank2,
  rank3,
  rank4,
  rank5,
  rank6,
  rank7,
  rank8,
  rank9,
];

const getTestImage = (gridIndex, charmIndex) => {
  // Map specific grid positions to specific images
  const imageMap = {
    0: rank1, // top-left
    1: rank2, // top-center
    2: rank3, // top-right
    5: rank4, // right-center
    8: rank5, // bottom-right
    7: rank6, // bottom-center
    6: rank7, // bottom-left
    3: rank8, // left-center
  };
  return imageMap[gridIndex] || rank1; // fallback to rank1
};

const FeatureIcon = ({
  image,
  title,
  description,
  active,
  isMobile,
  iconSize = 40,
}) => (
  <div
    style={{
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      textAlign: "center",
      width: isMobile ? "100%" : "220px",
      opacity: active ? 1 : 0.7,
      transition: "opacity 0.3s ease",
      padding: "0 10px",
    }}
  >
    <div
      style={{
        width: `${iconSize}px`,
        height: `${iconSize}px`,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        marginBottom: "12px",
      }}
    >
      <img
        src={image}
        alt={title || "icon"}
        style={{
          width: `${iconSize}px`,
          height: `${iconSize}px`,
          objectFit: "contain",
        }}
      />
    </div>
    {title && (
      <h4
        style={{
          color: "#fff",
          fontFamily: "'PlayfairDisplay', serif",
          margin: "0 0 8px 0",
          fontSize: "18px",
          fontWeight: "bold",
        }}
      >
        {title}
      </h4>
    )}
    <p
      style={{
        color: "rgba(255,255,255,0.7)",
        fontSize: "13px",
        margin: 0,
        lineHeight: "1.5",
        maxWidth: "180px",
      }}
    >
      {description}
    </p>
  </div>
);

const DottedLine = ({ isMobile }) =>
  isMobile ? null : (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        height: "40px",
        margin: "0 -45px",
        zIndex: 1,
      }}
    >
      <img
        src={natalArrow}
        alt="arrow"
        style={{ width: "130px", height: "8px", opacity: 1 }}
      />
    </div>
  );

const JourneySection = ({ isMobile, t }) => (
  <div
    style={{
      width: "100%",
      maxWidth: "1400px",
      margin: "60px auto 40px auto",
      textAlign: "center",
      color: "#DFBD69",
      position: "relative",
      zIndex: 2,
    }}
  >
    <h1
      style={{
        fontFamily: "'PlayfairDisplay', serif",
        fontSize: isMobile ? "36px" : "54px",
        fontWeight: "700",
        marginBottom: "15px",
        color: "#DFBD69",
      }}
    >
      {t("natalChart.charmheader")}
    </h1>
    <p
      style={{
        fontFamily: "'DMSans', sans-serif",
        fontSize: isMobile ? "16px" : "20px",
        marginBottom: "60px",
        opacity: 0.9,
        color: "#fff",
      }}
    >
      {t("natalChart.charmheader2")}
    </p>

    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: isMobile ? "center" : "flex-start",
        flexDirection: isMobile ? "column" : "row",
        gap: isMobile ? "14px" : "0px",
        flexWrap: "nowrap",
        padding: "0 20px",
        width: "100%",
        overflowX: isMobile ? "visible" : "hidden",
      }}
    >
      {/* <FeatureIcon 
        image={touch} 
        title="" 
        description={t("natalChart.DCsubheader1")}
        active={true}
        isMobile={isMobile}
        iconSize={60}
      />
      <DottedLine isMobile={isMobile} />
      <FeatureIcon 
        image={meditation} 
        title="" 
        description={t("natalChart.DCsubheader2")}
        active={true}
        isMobile={isMobile}
        iconSize={60}
      />
      <DottedLine isMobile={isMobile} /> */}
      <FeatureIcon
        image={calm}
        title=""
        description={t("natalChart.DCsubheader3")}
        active={true}
        isMobile={isMobile}
        iconSize={60}
      />
    </div>

    {/* Decorative Flourish */}
    <div
      style={{
        marginTop: "60px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        opacity: 1,
      }}
    >
      <img
        src={natalTitleFooter}
        alt="flourish"
        style={{ width: isMobile ? "280px" : "450px", height: "auto" }}
      />
    </div>
  </div>
);

const GRID_SIZE = 3;

const DigitalCharm = ({ onCharmClick = () => {} }) => {
  // Responsive image size (increased by 40%)
  const SCREEN_WIDTH = window.innerWidth;
  const isSmallScreen = SCREEN_WIDTH <= 320;
  const isMediumScreen = SCREEN_WIDTH > 320 && SCREEN_WIDTH <= 400;
  const imageSize = isSmallScreen ? 50 : isMediumScreen ? 60 : 70; // 32*1.4, 38*1.4, 44*1.4
  // Responsive top/bottom spacing
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 600);
  const FOOTER_SAFE_AREA = isMobile ? 120 : 120; // less bottom space on mobile
  const TOP_OFFSET = isMobile ? 70 : 150; // push grid further down on mobile

  // Scale the fixed-size canvas to fit mobile screens
  const [scale, setScale] = useState(1);
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 600);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  useEffect(() => {
    const BASE_VISUAL_WIDTH = 630; // includes arrows/text outside the 540px canvas
    const recalcScale = () => {
      const vw = Math.max(
        document.documentElement.clientWidth || 0,
        window.innerWidth || 0,
      );
      const padding = 24; // small side padding
      // Slightly boost the scale for a larger appearance on mobile
      const base = (vw - padding) / BASE_VISUAL_WIDTH;
      const boosted = base * 1.1; // +10%
      const next = Math.min(1, boosted);
      // Guard against NaN or negative
      setScale(Number.isFinite(next) && next > 0 ? next : 1);
    };
    recalcScale();
    window.addEventListener("resize", recalcScale);
    return () => window.removeEventListener("resize", recalcScale);
  }, []);

  const [modalOpen, setModalOpen] = useState(false);
  const [selectedCharm, setSelectedCharm] = useState(null);
  const [instructionText, setInstructionText] = useState(""); // Add this state

  const [charmData, setCharmData] = useState(new Array(8).fill(0));
  const [loading, setLoading] = useState(true);
  const [noCharms, setNoCharms] = useState(false);
  const [charmRedeemed, setCharmRedeemed] = useState();
  // center image to replace the redeemed count when available
  const [centerImageUrl, setCenterImageUrl] = useState(null);
  const [centerImageLoading, setCenterImageLoading] = useState(false);
  // Preview modal state for any charm (including center image)
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewImageUrl, setPreviewImageUrl] = useState(null);
  const [claimingAmulet, setClaimingAmulet] = useState(false);
  const [claimSuccessOpen, setClaimSuccessOpen] = useState(false);
  const [todayCharmCollected, setTodayCharmCollected] = useState(false); // NEW: Track today's collection
  const [lastCollectionDate, setLastCollectionDate] = useState(null);
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const [showLanguageDropdown, setShowLanguageDropdown] = useState(false);
  // const [selectedLanguage, setSelectedLanguage] = useState(
  //   localStorage.getItem('language') || 'en'
  // );

  const [modalShifted, setModalShifted] = useState(false);
  // Pagination state
  const [currentPage, setCurrentPage] = useState(0);
  const [zodiacCharms, setZodiacCharms] = useState([]);
  const CHARMS_PER_PAGE = 8;

  // Use a bundled fallback so the center box never appears empty
  const fallbackCenterImage = testImage;

  // Get indices of owned charms
  const ownedCharms = charmData; // Now an array of {name, created, expired, imgIdx, createdDate}

  // Clockwise grid positions (excluding center)
  const clockwiseGridIdx = [0, 1, 2, 5, 8, 7, 6, 3];

  // Map grid index to charm index for clockwise placement
  const gridToCharmIdx = {
    0: 0, // top-left
    1: 1, // top-center
    2: 2, // top-right
    5: 3, // right-center
    8: 4, // bottom-right
    7: 5, // bottom-center
    6: 6, // bottom-left
    3: 7, // left-center
  };

  const [username, setUsername] = useState(t("natalChart.guest"));

  // Dynamically shrink watermark font size so long usernames fit inside the cell width
  const computeWatermarkFontSize = (name) => {
    if (!name) return 32;
    const len = name.trim().length;
    // Base size 32px for <=10 chars, minimum 14px for very long names
    // Tweak sizes: smaller overall to better fit cells
    if (len <= 10) return 26; // base reduced from 32
    if (len >= 32) return 12; // minimum reduced from 14 and allow longer names
    // Linear scale between 26 and 12
    const maxLen = 32 - 10; // span
    const reduction = ((len - 10) / maxLen) * (26 - 12);
    return Math.round(26 - reduction);
  };

  const watermarkFontSize = computeWatermarkFontSize(username);

  const watermarkStyle = {
    position: "absolute",
    // place watermark near the top of the image instead of centered
    top: "8%",
    left: "50%",
    transform: "translate(-50%, 0)",
    color: "#ffffffff",
    fontSize: `${watermarkFontSize}px`,
    opacity: 0.25,
    pointerEvents: "none",
    userSelect: "none",
    fontWeight: "bold",
    textShadow: "1px 1px 4px #000",
    whiteSpace: "nowrap", // keep single line to preserve watermark feel
    fontStyle: "italic",
    maxWidth: "90%", // constrain inside cell
    overflow: "hidden",
    textOverflow: "ellipsis",
    letterSpacing: watermarkFontSize < 18 ? "0.5px" : undefined,
  };

  // Get user info from localStorage
  const userName = localStorage.getItem("username");
  const userID = localStorage.getItem("userID");
  // Maintain backward compatibility with existing code referencing ID
  const ID = userID;

  const location = useLocation();

  // Add this new useEffect to handle refresh when navigating from charm collection
  useEffect(() => {
    if (location.state?.refreshData) {
      // Force refresh of all data when coming from charm collection
      const refreshData = async () => {
        if (!ID) return;

        try {
          // Refresh charm redeemed count
          const response = await fetch(
            `https://xianhefairy.com/LotusFairy_API/api/booking/getDigitalCharm?ID=${ID}`,
          );
          const apiResult = await response.json();

          if (apiResult && apiResult.length > 0) {
            setCharmRedeemed(apiResult[0].REDEEM_CHARM);
            setLastCollectionDate(apiResult[0].LAST_UPDATE);
          }
        } catch (error) {
          console.error("Error refreshing charm data:", error);
        }
      };

      refreshData();

      // Clear the navigation state to prevent re-triggering
      window.history.replaceState({}, document.title);
    }
  }, [location.state, ID]);

  // Fetch username from API
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(
          "https://xianhefairy.com/LotusFairy_API/api/User/GetProfile",
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              UserName: userName,
              ID: userID,
              UserToken: "",
              Token: {
                AccessToken:
                  "xAfhn90xflfHfd.fjldfj@fdhLXHCHchlhsdflsdfhawWFRwzxxp",
              },
            }),
          },
        );

        const result = await response.json();
        if (response.ok && result.Profiles?.[0]) {
          const profile = result.Profiles[0];
          setUsername(profile.FullName);
        } else {
          setUsername(t("digitalCharm.guest"));
        }
      } catch (error) {
        setUsername(t("digitalCharm.guest"));
        console.error("Error fetching user data:", error);
      }
    };

    if (userName && userID) {
      fetchData();
    }
  }, [userName, userID]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (!ID) {
          setLoading(false);
          return;
        }

        // Fetch charm data (no getProduct call)
        const apiUrl = `https://xianhefairy.com/LotusFairy_API/api/CustCharm/GetAmulet?CustId=${ID}`;
        const response = await fetch(apiUrl);
        const apiResult = await response.json();
        console.log("Charm API result:", apiResult);

        if (apiResult?.length > 0) {
          const now = new Date();

          // Map API results to charm data, do NOT sort
          const allCharms = apiResult
            .map((item) => {
              let expiredDate = null;
              if (item.DateExpired) {
                try {
                  const dateStr = item.DateExpired.trim();
                  const [datePart, timePart, period] = dateStr.split(" ");
                  if (datePart && timePart) {
                    const [month, day, year] = datePart.split("/");
                    const [hours, minutes, seconds] = timePart.split(":");
                    let hour = parseInt(hours, 10);
                    if (period === "PM" && hour !== 12) {
                      hour += 12;
                    } else if (period === "AM" && hour === 12) {
                      hour = 0;
                    }
                    expiredDate = new Date(
                      parseInt(year, 10),
                      parseInt(month, 10) - 1,
                      parseInt(day, 10),
                      hour,
                      parseInt(minutes, 10),
                      parseInt(seconds, 10),
                    );
                    if (isNaN(expiredDate.getTime())) {
                      expiredDate = null;
                    }
                  }
                } catch (error) {
                  console.error("Error parsing date:", item.DateExpired, error);
                  expiredDate = null;
                }
              }
              const isExpired = expiredDate && expiredDate <= new Date();

              // Use ProdGif or ProdThumbnail for image
              const imageUrl = item.ProdGif || item.ProdThumbnail || "";

              return {
                name: item.LifeAreas || "Unknown",
                created: item.CreatedDate || "",
                expired: item.DateExpired || "",
                imgIdx: -1,
                createdDate: expiredDate,
                expiredDate,
                isExpired,
                imageUrl,
                description: item.CharmDesc || "",
                isFree: item.IsFree === 1,
                pid: item.Pid,
              };
            })
            .filter((charm) => !charm.isExpired);

          setCharmData(allCharms);
          setNoCharms(allCharms.length === 0);
        } else {
          setNoCharms(true);
        }
      } catch (error) {
        console.error("Error fetching charm data:", error);
        setNoCharms(true);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [ID]);

  // Update the charm combination logic (around line 342)
  const allValidCharms = charmData.filter((c) => c.createdDate && !c.isExpired);

  // Fetch charms and related images
  // useEffect(() => {
  //   const fetchData = async () => {
  //     try {
  //       if (!ID) {
  //         setLoading(false);
  //         return;
  //       }
  //       // Fetch charm meta info
  //       const apiUrl = `https://xianhefairy.com/LotusFairy_API/api/member/GetCustAmulet?id=${ID}`;
  //       const response = await fetch(apiUrl);
  //       const apiResult = await response.json();
  //       console.log("Charm API result:", apiResult);

  //       // Fetch product images
  //       const productRes = await fetch(
  //         "https://xianhefairy.com/LotusFairy_API/api/member/getProduct"
  //       );
  //       const productData = await productRes.json();

  //       if (apiResult?.length > 0) {
  //         const charmFields = [
  //           { name: "ROMANCE", created: "ROMANCE_CREATED", expired: "ROMANCE_EXPIRED", imgIdx: 0 },
  //           { name: "EDUCATION", created: "EDUC_CREATED", expired: "EDUC_EXPIRED", imgIdx: 1 },
  //           { name: "HEALTH", created: "HEALTH_CREATED", expired: "HEALTH_EXPIRED", imgIdx: 2 },
  //           { name: "LOVE", created: "LOVE_CREATED", expired: "LOVE_EXPIRED", imgIdx: 3 },
  //           { name: "WEALTH", created: "WEALTH_CREATED", expired: "WEALTH_EXPIRED", imgIdx: 4 },
  //           { name: "WISDOM", created: "WISDOM_CREATED", expired: "WISDOM_EXPIRED", imgIdx: 5 },
  //           { name: "PROSPERITY", created: "PROP_CREATED", expired: "PROP_EXPIRED", imgIdx: 6 },
  //           { name: "PROTECTION", created: "PROTECT_CREATED", expired: "PROTECT_EXPIRED", imgIdx: 7 },
  //         ];
  //         const now = new Date();

  //         // Helper to map charm name to product image
  //         const getImageUrl = (charmName) => {
  //           const match = productData.find((p) => {
  //             // Check LIFE_AREAS field first (most reliable)
  //             if (p.LIFE_AREAS && p.LIFE_AREAS.toLowerCase().includes(charmName.toLowerCase())) {
  //               return true;
  //             }
  //             // Fallback to checking DESC_ENG or CODE if needed
  //             if (p.DESC_ENG && p.DESC_ENG.toLowerCase().includes(charmName.toLowerCase())) {
  //               return true;
  //             }
  //             return false;
  //           });
  //           return match?.ImageUrl || "";
  //         };

  //         const allCharms = charmFields
  //           .map((c) => {
  //             const createdVal = apiResult[0][c.created];
  //             const expiredVal = apiResult[0][c.expired];
  //             if (!createdVal)
  //               return {
  //                 ...c,
  //                 createdDate: null,
  //                 expiredDate: null,
  //                 isExpired: false,
  //                 imageUrl: getImageUrl(c.name),
  //               };
  //             const createdDate = new Date(createdVal);
  //             const expiredDate = expiredVal ? new Date(expiredVal) : null;
  //             const isExpired = expiredDate && expiredDate <= now;

  //             // Debug log
  //             console.log(`Charm ${c.name}:`, {
  //               createdDate,
  //               expiredDate,
  //               isExpired,
  //               now
  //             });

  //             return {
  //               ...c,
  //               createdDate,
  //               expiredDate,
  //               isExpired,
  //               imageUrl: getImageUrl(c.name),
  //             };
  //           })
  //           .sort((a, b) => {
  //             if (!a.createdDate && !b.createdDate) return 0;
  //             if (!a.createdDate) return 1;
  //             if (!b.createdDate) return -1;
  //             return a.createdDate - b.createdDate;
  //           });

  //         console.log("All charms data:", allCharms);
  //         setCharmData(allCharms);
  //       } else {
  //         setNoCharms(true);
  //       }
  //     } catch (error) {
  //       setNoCharms(true);
  //     } finally {
  //       setLoading(false);
  //     }
  //   };
  //   fetchData();
  // }, []);

  // Fetch zodiac charms
  // useEffect(() => {
  //   const fetchZodiacCharms = async () => {
  //     try {
  //       if (!ID) return;

  //       // Fetch zodiac charms data
  //       const response = await fetch(
  //         `https://xianhefairy.com/LotusFairy_API/api/member/GetCustAmuletFree?id=${ID}`
  //       );
  //       const result = await response.json();
  //       console.log("Zodiac charms raw data:", result);

  //       // Fetch product data for image matching
  //       const productRes = await fetch(
  //         "https://xianhefairy.com/LotusFairy_API/api/member/getProduct"
  //       );
  //       const productData = await productRes.json();
  //       console.log("Product data for zodiac matching:", productData);

  //       if (result && result.length > 0) {
  //         const zodiacData = result
  //           .filter(item => item.LIFE_AREAS === "Zodiac")
  //           .map(item => {
  //             // Match CHARM_DESC with DESC_OTH from product data
  //             const matchedProduct = productData.find(p =>
  //               p.DESC_OTH && item.CHARM_DESC &&
  //               p.DESC_OTH.toLowerCase().trim() === item.CHARM_DESC.toLowerCase().trim()
  //             );

  //             console.log(`Matching zodiac charm: "${item.CHARM_DESC}"`, {
  //               found: !!matchedProduct,
  //               imageUrl: matchedProduct?.ImageUrl
  //             });

  //             return {
  //               name: "ZODIAC",
  //               created: "CREATED_DATE",
  //               expired: "DATE_EXPIRED",
  //               imgIdx: -1, // Special index for zodiac
  //               createdDate: item.CREATED_DATE ? new Date(item.CREATED_DATE) : null,
  //               expiredDate: item.DATE_EXPIRED ? new Date(item.DATE_EXPIRED) : null,
  //               isExpired: item.DATE_EXPIRED ? new Date(item.DATE_EXPIRED) <= new Date() : false,
  //               imageUrl: matchedProduct?.ImageUrl || "", // Use matched product image
  //               description: item.CHARM_DESC || "",
  //               isFree: item.ISFREE === 1,
  //             };
  //           });

  //         console.log("Processed zodiac charms:", zodiacData);
  //         setZodiacCharms(zodiacData);
  //       }
  //     } catch (error) {
  //       console.error("Error fetching zodiac charms:", error);
  //     }
  //   };

  //   fetchZodiacCharms();
  // }, [ID]);

  // // Combine life area charms and zodiac charms, then paginate
  // const allValidCharms = [
  //   ...charmData.filter(c => c.createdDate && !c.isExpired),
  //   ...zodiacCharms.filter(z => z.createdDate && !z.isExpired)
  // ].sort((a, b) => a.createdDate - b.createdDate);

  // Calculate pagination
  const totalPages = Math.ceil(allValidCharms.length / CHARMS_PER_PAGE);
  const startIdx = currentPage * CHARMS_PER_PAGE;
  const endIdx = startIdx + CHARMS_PER_PAGE;
  const currentPageCharms = allValidCharms.slice(startIdx, endIdx);

  // Navigation handlers
  const goToNextPage = () => {
    if (currentPage < totalPages - 1) {
      setCurrentPage(currentPage + 1);
    }
  };

  const goToPrevPage = () => {
    if (currentPage > 0) {
      setCurrentPage(currentPage - 1);
    }
  };

  const [apiInstructionText, setApiInstructionText] = useState("");
  useEffect(() => {
    const fetchInstruction = async () => {
      try {
        const langId = localStorage.getItem("languageId") || "2224"; // Default to 2224 (English) if not found

        const res = await fetch(
          `https://xianhefairy.com/LotusFairy_API/api/SiteContent/GetSiteContent?Code=ZATVQ&LangId=${langId}`,
        );
        const json = await res.json();
        if (Array.isArray(json) && json.length > 0 && json[0].Description) {
          setApiInstructionText(
            json[0].Description.replace(/<br\s*\/?>/gi, "\n"),
          );
        } else {
          // Set fallback text if API returns no data
          setApiInstructionText(
            '1. "Gently touch the amulet... breathe deeply, speak your wish… and hold it for two seconds."\n2. "Place your hand on the amulet... inhale slowly… offer your wish… and hold it in silence for two seconds."\n3. "Touch the amulet… draw in a deep breath… release your wish… and settle into two seconds of quiet."',
          );
        }
      } catch (err) {
        // Set fallback text if API call fails
        setApiInstructionText(
          '1. "Gently touch the amulet... breathe deeply, speak your wish… and hold it for two seconds."\n2. "Place your hand on the amulet... inhale slowly… offer your wish… and hold it in silence for two seconds."\n3. "Touch the amulet… draw in a deep breath… release your wish… and settle into two seconds of quiet."',
        );
      }
    };
    fetchInstruction();
  }, []);

  // Add this helper function after the watermarkFontSize calculation (around line 230)
  const getDirectionalTextStyle = (position) => {
    const isIndonesian = i18n.language === "id"; // Use i18n.language instead of selectedLanguage

    const baseStyles = {
      color: "#DFBD69",
      margin: 0,
      position: "absolute",
      fontSize: "9px",
      whiteSpace: "nowrap",
      zIndex: 10,
      zoom: 1.6,
    };

    // Adjust positions based on language
    switch (position) {
      case "topLeft":
        return {
          ...baseStyles,
          top: "25%",
          left: isIndonesian ? "-80px" : "-75px", // Adjust left position for Indonesian
          transform: "translateY(-50%) rotate(90deg)",
          transformOrigin: "center center",
        };
      case "bottomLeft":
        return {
          ...baseStyles,
          top: "72%",
          left: isIndonesian ? "-105px" : "-70px",
          transform: "translateY(-50%) rotate(90deg)",
          transformOrigin: "center center",
        };
      case "bottomRight":
        return {
          ...baseStyles,
          top: "72%",
          right: isIndonesian ? "-100px" : "-75px",
          transform: "translateY(-50%) rotate(-90deg)",
          transformOrigin: "center center",
        };
      case "topRight":
        return {
          ...baseStyles,
          top: "25%",
          right: isIndonesian ? "-100px" : "-70px",
          transform: "translateY(-50%) rotate(-90deg)",
          transformOrigin: "center center",
        };
      case "bottom":
        return {
          ...baseStyles,
          top: "108%",
          left: isIndonesian ? "28%" : "33%", // Adjust horizontal centering for Indonesian
          transform: "translateY(-50%)",
          transformOrigin: "center center",
        };
      default:
        return baseStyles;
    }
  };

  //           },
  //           {
  //             name: "EDUCATION",
  //             created: "EDUC_CREATED",
  //             expired: "EDUC_EXPIRED",
  //             imgIdx: 1,
  //           },
  //           {
  //             name: "HEALTH",
  //             created: "HEALTH_CREATED",
  //             expired: "HEALTH_EXPIRED",
  //             imgIdx: 2,
  //           },
  //           {
  //             name: "LOVE",
  //             created: "LOVE_CREATED",
  //             expired: "LOVE_EXPIRED",
  //             imgIdx: 3,
  //           },
  //           {
  //             name: "WEALTH",
  //             created: "WEALTH_CREATED",
  //             expired: "WEALTH_EXPIRED",
  //             imgIdx: 4,
  //           },
  //           {
  //             name: "WISDOM",
  //             created: "WISDOM_CREATED",
  //             expired: "WISDOM_EXPIRED",
  //             imgIdx: 5,
  //           },
  //           {
  //             name: "PROSPERITY",
  //             created: "PROP_CREATED",
  //             expired: "PROP_EXPIRED",
  //             imgIdx: 6,
  //           },
  //           {
  //             name: "PROTECTION",
  //             created: "PROTECT_CREATED",
  //             expired: "PROTECT_EXPIRED",
  //             imgIdx: 7,
  //           },
  //         ];
  //         const now = new Date();
  //         // Build array of all charms, marking expired ones
  //         const allCharms = charmFields
  //           .map((c) => {
  //             const createdVal = apiResult[0][c.created];
  //             const expiredVal = apiResult[0][c.expired];
  //             if (!createdVal)
  //               return {
  //                 ...c,
  //                 createdDate: null,
  //                 expiredDate: null,
  //                 isExpired: false,
  //               };
  //             const createdDate = new Date(createdVal);
  //             const expiredDate = expiredVal ? new Date(expiredVal) : null;
  //             const isExpired = expiredDate && expiredDate <= now;
  //             return {
  //               ...c,
  //               createdDate,
  //               expiredDate,
  //               isExpired,
  //               // imageUrl: "https://xianhefairy.com:4433/images/product/00024/paid%20charm%202.gif", // <-- Direct link here
  //             };
  //           })
  //           .sort((a, b) => {
  //             // Sort by createdDate, nulls last
  //             if (!a.createdDate && !b.createdDate) return 0;
  //             if (!a.createdDate) return 1;
  //             if (!b.createdDate) return -1;
  //             return a.createdDate - b.createdDate;
  //           });

  //         setCharmData(allCharms);
  //         setNoCharms(allCharms.every((c) => !c.createdDate));
  //       } else {
  //         setNoCharms(true);
  //       }
  //     } catch (error) {
  //       setNoCharms(true);
  //     } finally {
  //       setLoading(false);
  //     }
  //   };
  //   fetchData();
  // }, []);

  // Update the useEffect that fetches charm data to also get the last update date
  useEffect(() => {
    if (!ID) return;

    fetch(
      `https://xianhefairy.com/LotusFairy_API/api/booking/getDigitalCharm?ID=${ID}`,
    )
      .then((response) => response.json())
      .then((apiResult) => {
        if (!apiResult || apiResult.length === 0) {
          console.error("API returned empty data");
          return;
        }
        console.log("Setting charmRedeemed to:", apiResult[0].REDEEM_CHARM);
        setCharmRedeemed(apiResult[0].REDEEM_CHARM);
        // Also store the last update date
        setLastCollectionDate(apiResult[0].LAST_UPDATE);
        console.log("Charm redeemed count:", apiResult[0].REDEEM_CHARM);
        console.log("Last collection date:", apiResult[0].LAST_UPDATE);
      })
      .catch((error) => console.error("Error fetching data:", error));
  }, [ID]);

  // Helper function to check if charm was collected today
  const isCharmCollectedToday = () => {
    if (!lastCollectionDate) return false;

    const toLocalDateString = (dateObj) => {
      const year = dateObj.getFullYear();
      const month = String(dateObj.getMonth() + 1).padStart(2, "0");
      const day = String(dateObj.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    };

    const todayLocal = toLocalDateString(new Date());
    const parsedCollectionDate = new Date(lastCollectionDate);
    const collectionDateLocal = Number.isNaN(parsedCollectionDate.getTime())
      ? String(lastCollectionDate).split("T")[0]
      : toLocalDateString(parsedCollectionDate);

    console.log("Collection date (local):", collectionDateLocal);
    console.log("Today (local):", todayLocal);
    console.log("Dates match:", todayLocal === collectionDateLocal);

    return todayLocal === collectionDateLocal;
  };

  const sendDigitalCharmPurchase = async (apiResult) => {
    const now = new Date();
    const nextRedeemCount = (Number(apiResult?.REDEEM_CHARM) || 0) + 1;

    const updatedCharmData = {
      UID: apiResult?.UID || "",
      DC_1: apiResult?.DC_1 || "",
      DC_2: apiResult?.DC_2 || "",
      DC_3: apiResult?.DC_3 || "",
      DC_4: apiResult?.DC_4 || "",
      DC_5: apiResult?.DC_5 || "",
      DC_6: apiResult?.DC_6 || "",
      DC_7: apiResult?.DC_7 || "",
      DC_8: apiResult?.DC_8 || "",
      DC_9: apiResult?.DC_9 || "",
      CUST_ID: ID,
      REDEEM_CHARM: nextRedeemCount,
      STATUS: 1,
      CREATED_BY: "AdminUser",
      CREATED_DATE: apiResult?.CREATED_DATE || now.toISOString(),
      UPDATED_BY: "AdminUser",
      LAST_UPDATE: now.toISOString(),
    };

    try {
      const saveResponse = await fetch(
        "https://xianhefairy.com/LotusFairy_API/api/booking/saveDigitalCharm",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(updatedCharmData),
        },
      );

      const saveData = await saveResponse.json();
      console.log("Digital charm saved:", saveData);
      console.log("Updated LAST_UPDATE to:", now.toISOString());

      // Refresh local state immediately so UI swaps claim button to amulet.
      setLastCollectionDate(now.toISOString());
      setCharmRedeemed(nextRedeemCount);
      setCenterImageUrl((prev) => prev || fallbackCenterImage);
      setClaimSuccessOpen(true);
    } catch (error) {
      console.error("Error sending digital charm purchase:", error);
    }
  };

  const redeemCharm = async () => {
    if (!ID || claimingAmulet || isCharmCollectedToday()) return;

    setClaimingAmulet(true);
    try {
      const response = await fetch(
        `https://xianhefairy.com/LotusFairy_API/api/booking/getDigitalCharm?ID=${ID}`,
      );
      const apiResult = await response.json();

      let charmRecord;
      if (!apiResult || apiResult.length === 0) {
        console.warn(
          "API returned empty data, creating new charm record for first claim",
        );
        charmRecord = {
          UID: "",
          DC_1: "",
          DC_2: "",
          DC_3: "",
          DC_4: "",
          DC_5: "",
          DC_6: "",
          DC_7: "",
          DC_8: "",
          DC_9: "",
          REDEEM_CHARM: 0,
        };
      } else {
        charmRecord = apiResult[0];
      }

      await sendDigitalCharmPurchase(charmRecord);
      console.log("Charm redeemed count:", charmRecord.REDEEM_CHARM);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setClaimingAmulet(false);
    }
  };

  // useEffect(() => {
  //   if (!ID) return;

  //   fetch(
  //     `https://xianhefairy.com/LotusFairy_API/api/booking/getDigitalCharm?ID=${ID}`
  //   )
  //     .then((response) => response.json())
  //     .then((apiResult) => {
  //       if (!apiResult || apiResult.length === 0) {
  //         console.error("API returned empty data");
  //         return;
  //       }
  //       console.log("Setting charmRedeemed to:", apiResult[0].REDEEM_CHARM);
  //       setCharmRedeemed(apiResult[0].REDEEM_CHARM);
  //       // sendDigitalCharmPurchase(apiResult[0]);
  //       console.log("Charm redeemed count:", apiResult[0].REDEEM_CHARM);
  //     })
  //     .catch((error) => console.error("Error fetching data:", error));
  // }, [ID]);

  // Update the center image fetch logic
  useEffect(() => {
    const fetchCenterImage = async () => {
      console.log("Fetching center image, charmRedeemed:", charmRedeemed);

      // Check both conditions: charm must be redeemed AND collected today
      if (!charmRedeemed || charmRedeemed === 0 || !isCharmCollectedToday()) {
        console.log("No charm redeemed today, hiding center image");
        setCenterImageUrl(null);
        return;
      }

      try {
        setCenterImageLoading(true);
        console.log("Starting image fetch...");

        const apiUrl = `https://xianhefairy.com/LotusFairy_API/api/member/services/images`;
        const res = await fetch(apiUrl);

        if (!res.ok) {
          console.error(`Failed to fetch image metadata: ${res.status}`);
          setCenterImageUrl(fallbackCenterImage);
          setCenterImageLoading(false);
          return;
        }

        const json = await res.json();
        console.log("Image metadata API response:", json);

        if (!Array.isArray(json) || json.length === 0) {
          console.warn("No image data returned from API, using fallback");
          setCenterImageUrl(fallbackCenterImage);
          setCenterImageLoading(false);
          return;
        }

        const imageData = json[0];

        // Check if the image is still valid based on ValidDate
        if (imageData.ValidDate) {
          const validUntil = new Date(imageData.ValidDate);
          const now = new Date();

          console.log("Image valid until:", validUntil);
          console.log("Current date:", now);

          // If image has expired, use fallback
          if (now > validUntil) {
            console.log("Image has expired, using fallback");
            setCenterImageUrl(fallbackCenterImage);
            setCenterImageLoading(false);
            return;
          }
        }

        if (!imageData.Image || !imageData.ProdId) {
          console.warn("No image or ProdId found in API response");
          setCenterImageUrl(fallbackCenterImage);
          setCenterImageLoading(false);
          return;
        }

        const prodId = String(imageData.ProdId);
        const filename = imageData.Image;
        const padded = prodId.padStart(5, "0");
        const imageUrl = `https://xianhefairy.com:4433/images/services/${padded}/${filename}`;

        console.log("Setting center image URL:", imageUrl);
        setCenterImageUrl(imageUrl);
      } catch (err) {
        console.error("Error fetching center image:", err);
        setCenterImageUrl(fallbackCenterImage);
      } finally {
        setCenterImageLoading(false);
      }
    };

    fetchCenterImage();
  }, [charmRedeemed, lastCollectionDate, fallbackCenterImage]); // Add lastCollectionDate to dependencies

  // When a charm is redeemed (truthy), try to fetch the service image
  //   useEffect(() => {
  //   const fetchCenterImage = async () => {
  //     console.log("Fetching center image, charmRedeemed:", charmRedeemed);
  //     console.log("Fallback image URL:", fallbackCenterImage);

  //     // Check if charmRedeemed is truthy (could be 1, 2, 3, etc.)
  //     if (!charmRedeemed || charmRedeemed === 0) {
  //       console.log("No charm redeemed, skipping image fetch");
  //       setCenterImageUrl(null);
  //       return;
  //     }

  //     try {
  //       // indicate loading started
  //       setCenterImageLoading(true);
  //       console.log("Starting image fetch...");

  //       // First get the image metadata with ProdId and Image filename
  //       const apiUrl = `https://xianhefairy.com/LotusFairy_API/api/member/services/images`;
  //       const res = await fetch(apiUrl);

  //       if (!res.ok) {
  //         console.error(`Failed to fetch image metadata: ${res.status}`);
  //         console.log("Setting fallback due to API failure:", fallbackCenterImage);
  //         setCenterImageUrl(fallbackCenterImage);
  //         setCenterImageLoading(false);
  //         return;
  //       }

  //   const json = await res.json();
  //       console.log("Image metadata API response:", json);

  //       if (!Array.isArray(json) || json.length === 0) {
  //         console.warn("No image data returned from API, using fallback:", fallbackCenterImage);
  //         setCenterImageUrl(fallbackCenterImage);
  //         setCenterImageLoading(false);
  //         return;
  //       }

  //       // Use the ProdId and Image from the API response
  //       const imageData = json[0];
  //       if (!imageData.Image || !imageData.ProdId) {
  //         console.warn("No image or ProdId found in API response, using fallback:", imageData);
  //         console.log("Setting fallback:", fallbackCenterImage);
  //         setCenterImageUrl(fallbackCenterImage);
  //         setCenterImageLoading(false);
  //         return;
  //       }

  //       // Use the actual ProdId from the API response
  //       const prodId = String(imageData.ProdId);
  //       const filename = imageData.Image;

  //       // Zero-pad to 5 digits like 00099
  //       const padded = prodId.padStart(5, "0");
  //       const imageUrl = `https://xianhefairy.com:4433/images/services/${padded}/${filename}`;

  //       console.log("Setting center image URL:", imageUrl);
  //       setCenterImageUrl(imageUrl);

  //     } catch (err) {
  //       console.error("Error fetching center image:", err);
  //       console.log("Using fallback image due to error:", fallbackCenterImage);
  //       setCenterImageUrl(fallbackCenterImage);
  //     } finally {
  //       setCenterImageLoading(false);
  //     }
  //   };

  //   fetchCenterImage();
  // }, [charmRedeemed, fallbackCenterImage]);

  // Show a brief preview and highlight when center image becomes available
  //   useEffect(() => {
  //   console.log("Modal effect triggered - centerImageUrl:", centerImageUrl, "charmRedeemed:", charmRedeemed);
  //   let timer;
  //   if (centerImageUrl && charmRedeemed) {
  //     console.log("Showing center preview for:", centerImageUrl);
  //     setShowCenterPreview(true);
  //     // Auto-close after 1.5 seconds
  //     timer = setTimeout(() => setShowCenterPreview(false), 1500);
  //   }
  //   return () => clearTimeout(timer);
  // }, [centerImageUrl, charmRedeemed]);

  // useEffect(() => {
  //   let timer;
  //   if (centerImageUrl) {
  //     setShowCenterPreview(true);
  //     // Auto-close after 1.5 seconds
  //     timer = setTimeout(() => setShowCenterPreview(false), 1500);
  //   }
  //   return () => clearTimeout(timer);
  // }, [centerImageUrl]);

  // Auto-show modal for fallback image when component mounts
  // useEffect(() => {
  //   let timer;
  //   // Only show fallback modal if there's a redeemed charm but no centerImageUrl
  //   if (!loading && charmRedeemed && !centerImageUrl) {
  //     setShowCenterPreview(true);
  //     // Auto-close after 1.5 seconds
  //     timer = setTimeout(() => setShowCenterPreview(false), 1500);
  //   }
  //   return () => clearTimeout(timer);
  // }, [loading, charmRedeemed, centerImageUrl]);

  // Ensure we at least try to fetch the example service image (prodId 92)
  // once on mount so the center box shows an image by default.
  // useEffect(() => {
  //   const fetchFallback = async () => {
  //     if (centerImageUrl) return; // already set
  //     const prodId = "100";
  //     const apiUrl = `https://xianhefairy.com/LotusFairy_API/api/member/services/images/${prodId}`;
  //     try {
  //       const res = await fetch(apiUrl);
  //       if (!res.ok) return;
  //       const json = await res.json();
  //       if (Array.isArray(json) && json.length > 0 && json[0].Image) {
  //         const filename = json[0].Image;
  //         const padded = prodId.padStart(5, "0");
  //         const imageUrl = `https://xianhefairy.com:4433/images/services/${padded}/${filename}`;
  //         setCenterImageUrl(imageUrl);
  //       }
  //     } catch (err) {
  //       console.error("Fallback center image fetch failed:", err);
  //     }
  //   };
  //   fetchFallback();
  // }, []);

  const modalPortalTarget =
    typeof document !== "undefined" ? document.body : null;

  if (loading) {
    return (
      <div style={{ color: "#DFBD69", textAlign: "center" }}>Loading...</div>
    );
  }

  // 3x3 grid placeholder array
  const gridItems = Array.from({ length: 9 });

  return (
    <div
      style={{
        // Allow page to grow and scroll so it doesn't get hidden behind footer
        //minHeight: "60vh",
        //height: "100vh",
        width: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "flex-start", // Changed from "center" to "flex-start"
        paddingBottom: FOOTER_SAFE_AREA, // Prevent overlap with footer
        boxSizing: "border-box",
        position: "relative",
        overflowX: "hidden",
      }}
    >
      {/* Wrapper to scale down all content slightly */}
      <div
        style={{
          transform: "scale(0.85)",
          transformOrigin: "top center",
          width: "100%",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          paddingBottom: 20,
          paddingLeft: 12,
          paddingRight: 12,
          boxSizing: "border-box",
        }}
      >
        {/* Back Button matching FortuneStick */}
        <div
          style={{
            width: "100%",
            maxWidth: "1200px",
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-start",
            marginBottom: "10px",
            position: "absolute",
            top: "20px",
            left: "50%",
            transform: "translateX(-50%)",
            padding: "0 20px",
            boxSizing: "border-box",
            zIndex: 10,
          }}
        >
          <button
            style={{
              background: "transparent",
              border: "none",
              color: "#dfbd69",
              fontSize: "24px",
              cursor: "pointer",
            }}
            onClick={() => navigate("/chart")}
          >
            &#8592;
          </button>
        </div>

        <JourneySection isMobile={isMobile} t={t} />

        {/* Instruction text - shown above grid when modal is shifted */}
        {instructionText && modalShifted && (
          <div
            style={{
              background: "rgba(212, 175, 55, 0.35)",
              color: "#fff2d2",
              padding: "32px 24px 24px",
              borderRadius: "20px",
              fontSize: "17px",
              fontWeight: "400",
              textAlign: "center",
              width: "90vw",
              maxWidth: "550px",
              boxShadow: "0 2px 24px rgba(223,189,105,0.10)",
              marginTop: isMobile ? "20px" : "20px",
              marginBottom: "-60px",
              display: "flex",
              flexDirection: isMobile ? "column" : "row",
              gap: "32px",
              justifyContent: "space-between",
              alignItems: "flex-start",
              zIndex: 10001,
            }}
          >
            {instructionText
              .split(/\n+/)
              .filter(Boolean)
              .map((line, idx) => {
                // Choose image based on instruction number
                let imgSrc;
                if (idx === 0) imgSrc = touch;
                else if (idx === 1) imgSrc = meditation;
                else if (idx === 2) imgSrc = calm;
                return (
                  <div key={idx} style={{ flex: 1, textAlign: "center" }}>
                    <img
                      src={imgSrc}
                      alt={`Instruction ${idx + 1}`}
                      style={{
                        width: 48,
                        height: 48,
                        marginBottom: 12,
                        objectFit: "contain",
                        display: "block",
                        marginLeft: "auto",
                        marginRight: "auto",
                      }}
                    />
                    {line}
                  </div>
                );
              })}
          </div>
        )}

        {/* Top border container */}
        {/* <div
        style={{
          border: "2px solid #DFBD69",
          borderBottom: "none",
          margin: "0 auto",
          marginBottom: "0px",
          maxWidth: "560px", // Reduced from 650px
          width: "524px",    // Reduced from 630px
          height: "42px",    // Reduced from 48px
        }}
      ></div> */}
        {/* Responsive container that scales the fixed canvas for mobile */}
        <div
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "center",
            position: "relative",
            overflow: "visible",
            marginTop: isMobile ? "10px" : "-50px",
          }}
        >
          {/* Sizer reserves vertical space equal to the scaled canvas height so layout doesn't overlap */}
          <div
            aria-hidden
            style={{ height: `${TOP_OFFSET + 720 * scale}px` }}
          />
          {/* Scaled canvas holding the original fixed layout */}
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(3, 1fr)",
              gridTemplateRows: "repeat(3, 1fr)", // Ensure equal row heights
              gap: "0px",
              width: "540px",
              height: "720px",
              position: "absolute",
              top: TOP_OFFSET,
              left: "50%",
              transform: `translateX(-50%) scale(${scale})`,
              transformOrigin: "top center",
              margin: "0 auto",
              alignContent: "center",
              justifyItems: "center",
              alignItems: "center",
              placeItems: "center",
              overflow: "visible",
            }}
          >
            <p style={getDirectionalTextStyle("topLeft")}>
              {t("natalChart.growHealth")}
            </p>
            <p style={getDirectionalTextStyle("bottomLeft")}>
              {t("natalChart.growWiser")}
            </p>
            <p style={getDirectionalTextStyle("bottomRight")}>
              {t("natalChart.growWealth")}
            </p>
            <p style={getDirectionalTextStyle("topRight")}>
              {t("natalChart.growUnity")}
            </p>
            <p style={getDirectionalTextStyle("bottom")}>
              {t("natalChart.growBetter")}
            </p>

            {/* 3x3 Grid inside the canvas */}
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(3, 1fr)",
                gap: "0px",
                width: "420px",
                height: "700px",
                position: "relative",
                margin: "0 auto",
                alignContent: "center",
                justifyItems: "center",
                alignItems: "center",
                placeItems: "center",
              }}
            >
              {/* Arrows */}
              <img
                src={require("../Assets/arrow.png")}
                alt="Top Left Arrow"
                style={{
                  position: "absolute",
                  top: "-40px", // Increased proportionally
                  left: "-30px", // Increased proportionally
                  width: "60px", // Increased from 48px
                  height: "60px", // Increased from 48px
                  transform: "rotate(-135deg)",
                  zIndex: 5,
                  filter:
                    "drop-shadow(0 0 1px #DFBD69) drop-shadow(0 0 1px #DFBD69)",
                }}
              />
              <img
                src={require("../Assets/arrow.png")}
                alt="Top Middle Arrow"
                style={{
                  position: "absolute",
                  top: "-62px", // Increased proportionally
                  left: "240px", // Adjusted for new grid size (540/3 * 1.33)
                  width: "60px",
                  height: "60px",
                  transform: "rotate(-90deg)",
                  zIndex: 5,
                  filter:
                    "drop-shadow(0 0 1px #DFBD69) drop-shadow(0 0 1px #DFBD69)",
                }}
              />
              <img
                src={require("../Assets/arrow.png")}
                alt="Top Right Arrow"
                style={{
                  position: "absolute",
                  top: "-40px", // Increased proportionally
                  right: "-150px",
                  width: "60px",
                  height: "60px",
                  transform: "rotate(-45deg)",
                  zIndex: 5,
                  filter:
                    "drop-shadow(0 0 1px #DFBD69) drop-shadow(0 0 1px #DFBD69)",
                }}
              />
              <img
                src={require("../Assets/arrow.png")}
                alt="Middle Left Arrow"
                style={{
                  position: "absolute",
                  top: "50%",
                  left: "-54px", // Increased proportionally
                  width: "60px",
                  height: "60px",
                  transform: "translateY(-50%) rotate(180deg)",
                  zIndex: 5,
                  filter:
                    "drop-shadow(0 0 1px #DFBD69) drop-shadow(0 0 1px #DFBD69)",
                }}
              />
              <img
                src={require("../Assets/arrow.png")}
                alt="Middle Right Arrow"
                style={{
                  position: "absolute",
                  top: "50%",
                  right: "-174px", // Increased proportionally
                  width: "60px",
                  height: "60px",
                  transform: "translateY(-50%) rotate(0deg)",
                  zIndex: 5,
                  filter:
                    "drop-shadow(0 0 1px #DFBD69) drop-shadow(0 0 1px #DFBD69)",
                }}
              />
              <img
                src={require("../Assets/arrow.png")}
                alt="Bottom Left Arrow"
                style={{
                  position: "absolute",
                  bottom: "-40px", // Increased proportionally
                  left: "-30px",
                  width: "60px",
                  height: "60px",
                  transform: "rotate(135deg)",
                  zIndex: 5,
                  filter:
                    "drop-shadow(0 0 1px #DFBD69) drop-shadow(0 0 1px #DFBD69)",
                }}
              />
              <img
                src={require("../Assets/arrow.png")}
                alt="Bottom Middle Arrow"
                style={{
                  position: "absolute",
                  bottom: "-64px", // Increased proportionally
                  left: "240px", // Adjusted for new grid size
                  width: "60px",
                  height: "60px",
                  transform: "rotate(90deg)",
                  zIndex: 5,
                  filter:
                    "drop-shadow(0 0 1px #DFBD69) drop-shadow(0 0 1px #DFBD69)",
                }}
              />
              <img
                src={require("../Assets/arrow.png")}
                alt="Bottom Right Arrow"
                style={{
                  position: "absolute",
                  bottom: "-40px", // Increased proportionally
                  right: "-150px",
                  width: "60px",
                  height: "60px",
                  transform: "rotate(45deg)",
                  zIndex: 5,
                  filter:
                    "drop-shadow(0 0 1px #DFBD69) drop-shadow(0 0 1px #DFBD69)",
                }}
              />

              {/* Grid Items */}
              {gridItems.map((_, idx) => {
                // Set new cell sizes for all cells
                const cellWidth = "180px"; // Increased from 140px (540px / 3)
                const cellHeight = "240px"; // Increased from 187px (720px / 3)

                if (idx === 4) {
                  // Center cell - keep existing center cell code
                  const shouldShowCenterImage =
                    centerImageUrl && charmRedeemed && charmRedeemed > 0;
                  // only allow claiming when the user is signed in (ID truthy)
                  const canClaimFreeAmulet =
                    ID && !isCharmCollectedToday() && !claimingAmulet;

                  return (
                    <div
                      key={idx}
                      style={{
                        width: cellWidth,
                        height: cellHeight,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        background: "#333",
                        borderRadius: "0px",
                        boxShadow:
                          previewOpen && previewImageUrl === centerImageUrl
                            ? "0 0 24px 8px rgba(223,189,105,0.45)"
                            : "none",
                        gridColumn: "2 / 3",
                        gridRow: "2 / 3",
                        position: "relative",
                        cursor:
                          shouldShowCenterImage || canClaimFreeAmulet
                            ? "pointer"
                            : "default",
                      }}
                      onClick={() => {
                        if (shouldShowCenterImage) {
                          setPreviewImageUrl(centerImageUrl);
                          setPreviewOpen(true);
                        } else if (canClaimFreeAmulet) {
                          redeemCharm();
                        } else if (!ID && !isCharmCollectedToday()) {
                          // user not signed in — redirect to signin FROM main menu
                          localStorage.setItem("openLoginPanel", "true");
                          navigate("/main");
                        }
                      }}
                    >
                      {centerImageLoading ? (
                        <span style={{ color: "#DFBD69" }}>Loading...</span>
                      ) : shouldShowCenterImage ? (
                        <>
                          <img
                            src={centerImageUrl}
                            alt="Center Image"
                            style={{
                              maxWidth: "90%",
                              maxHeight: "90%",
                              objectFit: "contain",
                              borderRadius: 8,
                              cursor: "pointer",
                              display: "block",
                              willChange: "transform", // Add this
                              backfaceVisibility: "hidden", // Add this
                              pointerEvents: "none", // Prevent drag
                              userSelect: "none", // Prevent selection
                            }}
                            onContextMenu={(e) => e.preventDefault()} // Disable right-click
                            draggable={false}
                            onClick={(e) => {
                              e.stopPropagation();
                              setPreviewImageUrl(centerImageUrl);
                              setPreviewOpen(true);
                            }}
                            onError={(e) => {
                              console.error("Center image failed to load");
                              e.currentTarget.src = fallbackCenterImage;
                            }}
                          />
                          <div style={watermarkStyle}>{username}</div>
                        </>
                      ) : (
                        <>
                          {canClaimFreeAmulet ? (
                            <button
                              onClick={(e) => {
                                e.stopPropagation();
                                redeemCharm();
                              }}
                              disabled={claimingAmulet}
                              style={{
                                background: "#000",
                                color: "#DFBD69",
                                border: "1px solid #DFBD69",
                                borderRadius: 12,
                                padding: "8px 12px",
                                fontSize: 13,
                                fontWeight: 600,
                                cursor: claimingAmulet
                                  ? "not-allowed"
                                  : "pointer",
                                opacity: claimingAmulet ? 0.7 : 1,
                                zIndex: 2,
                              }}
                            >
                              {claimingAmulet
                                ? t("natalChart.claimingAmu", "Claiming...")
                                : t(
                                    "natalChart.claimFreeAmu",
                                    "Claim Free A-Mu",
                                  )}
                            </button>
                          ) : (
                            // Not signed in: show Sign In CTA
                            !isCharmCollectedToday() && (
                              <button
                                onClick={() => {
                                  localStorage.setItem(
                                    "openLoginPanel",
                                    "true",
                                  );
                                  navigate("/main");
                                }}
                                style={{
                                  background: "#000",
                                  color: "#DFBD69",
                                  border: "1px solid #DFBD69",
                                  borderRadius: 12,
                                  padding: "8px 12px",
                                  fontSize: 13,
                                  fontWeight: 600,
                                  cursor: "pointer",
                                  zIndex: 2,
                                }}
                              >
                                {t("account.signIn", "Sign In to Claim")}
                              </button>
                            )
                          )}
                          <span
                            style={{
                              color: "#DFBD69",
                              fontWeight: "bold",
                              fontSize: "31px",
                            }}
                          ></span>
                          <div style={watermarkStyle}>{username}</div>
                        </>
                      )}
                    </div>
                  );
                }

                // For non-center cells, map directly to charm index
                // The grid positions are already in clockwise order [0,1,2,5,8,7,6,3]
                const gridOrder = [0, 1, 2, 5, 8, 7, 6, 3];
                const positionInGrid = gridOrder.indexOf(idx);

                // Get the charm at this position from paginated charms
                // This automatically fills gaps left by expired charms
                const charm = currentPageCharms[positionInGrid];

                console.log(`Grid ${idx}, Position ${positionInGrid}:`, {
                  charm: charm?.name,
                  description: charm?.description,
                  isExpired: charm?.isExpired,
                  createdDate: charm?.createdDate,
                  imageUrl: charm?.imageUrl,
                });

                // Show charm if it exists and is valid
                if (charm && charm.createdDate && !charm.isExpired) {
                  return (
                    <div
                      key={idx}
                      style={{
                        width: cellWidth,
                        height: cellHeight,
                        backgroundColor: "#1a1a1a",
                        borderRadius: "0px",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                        position: "relative",
                        transition: "all 0.3s ease",
                        cursor: "pointer",
                      }}
                      onClick={() => {
                        onCharmClick({ charm, imgSrc: charm.imageUrl });
                        if (charm.imageUrl) {
                          setPreviewImageUrl(charm.imageUrl);
                          setPreviewOpen(true);
                        }
                      }}
                    >
                      <img
                        src={charm.imageUrl}
                        alt={charm.description || charm.name}
                        style={{
                          maxWidth: "90%",
                          maxHeight: "90%",
                          objectFit: "contain",
                          borderRadius: 8,
                          cursor: "pointer",
                          display: "block",
                          willChange: "transform", // Add this to force GPU acceleration
                          backfaceVisibility: "hidden", // Add this to prevent rendering issues
                          pointerEvents: "none", // Prevent drag
                          userSelect: "none", // Prevent selection
                        }}
                        onContextMenu={(e) => e.preventDefault()} // Disable right-click
                        draggable={false}
                        onError={(e) => {
                          console.error(
                            `Failed to load image for ${charm.name}`,
                          );
                          e.currentTarget.style.display = "none";
                        }}
                      />
                      <div style={watermarkStyle}>{username}</div>
                    </div>
                  );
                }

                // Show placeholder for empty slots (clickable - go to Shop)
                return (
                  <div
                    key={idx}
                    role="button"
                    tabIndex={0}
                    onClick={(e) => {
                      e.stopPropagation();
                      navigate("/shop");
                    }}
                    onKeyDown={(e) => {
                      if (e.key === "Enter" || e.key === " ") {
                        e.preventDefault();
                        navigate("/shop");
                      }
                    }}
                    style={{
                      width: cellWidth,
                      height: cellHeight,
                      backgroundColor: "#333",
                      borderRadius: "0px",
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "center",
                      position: "relative",
                      transition: "all 0.3s ease",
                      cursor: "pointer",
                    }}
                  >
                    <div
                      style={{
                        color: "#666",
                        fontSize: "34px",
                        fontWeight: "300",
                      }}
                    >
                      +
                    </div>
                    <div style={watermarkStyle}>{username}</div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
        {/* Pagination controls - also shown at bottom */}
        {totalPages > 1 && (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "20px",
              marginTop: "80px",
              color: "#DFBD69",
            }}
          >
            <button
              onClick={goToPrevPage}
              disabled={currentPage === 0}
              style={{
                background: currentPage === 0 ? "#555" : "#DFBD69",
                color: currentPage === 0 ? "#888" : "#000",
                border: "none",
                padding: "8px 16px",
                borderRadius: "4px",
                cursor: currentPage === 0 ? "not-allowed" : "pointer",
                fontWeight: "bold",
                minWidth: "100px", // <-- Add this line
              }}
            >
              Previous
            </button>
            <span style={{ fontSize: "16px", fontWeight: "bold" }}>
              Page {currentPage + 1} of {totalPages}
            </span>
            <button
              onClick={goToNextPage}
              disabled={currentPage === totalPages - 1}
              style={{
                background: currentPage === totalPages - 1 ? "#555" : "#DFBD69",
                color: currentPage === totalPages - 1 ? "#888" : "#000",
                border: "none",
                padding: "8px 16px",
                borderRadius: "4px",
                cursor:
                  currentPage === totalPages - 1 ? "not-allowed" : "pointer",
                fontWeight: "bold",
                minWidth: "100px", // <-- Add this line
              }}
            >
              Next
            </button>
          </div>
        )}
        {/* Bottom border container */}
        {/* <div
         style={{
          border: "2px solid #DFBD69",
          borderTop: "none",
          margin: "0 auto",
          marginTop: "0px",
          maxWidth: "560px", // Reduced from 650px
          width: "524px",    // Reduced from 630px
          height: "42px",    // Reduced from 48px
        }}
      ></div> */}
        <style>
          {`
        .digital-charm-instruction {
          position: absolute;
          top: -10%;
          left: 50%;
          transform: translate(-50%, -50%);
          background: #6a613c;
          color: #fff;
          padding: 32px 24px 24px;
          border-radius: 20px;
          font-size: 17px;
          font-weight: 400;
          text-align: center;
          width: 90vw;
          max-width: 550px;
          box-shadow: 0 2px 24px rgba(223,189,105,0.10);
          z-index: 10;
          display: flex;
          flex-direction: row;
          gap: 32px;
          justify-content: space-between;
          align-items: flex-start;
        }
        .amulet-modal-backdrop {
            padding-top: ${
              modalShifted ? `${TOP_OFFSET + 85}px` : `${TOP_OFFSET - 45}px`
            } !important;
          }
        // .amulet-modal-buttons {
        //   padding: 24px 24px 42px !important;
        // }
        @media (max-width: 1440px) {
          .digital-charm-instruction {
            top: -13% !important;
            width: 50vw;
            font-size: 15px;
            padding: 10px 8px;
          }
          .amulet-modal-backdrop {
            padding-top: ${
              modalShifted ? `${TOP_OFFSET + 85}px` : `${TOP_OFFSET - 0}px`
            } !important;
          }
          // .amulet-modal {
          //   padding: 24px 24px 42px !important;
            
          // }
          // .amulet-modal-buttons {
          //   padding: 24px 24px 42px !important;
          // }
        }
        @media (max-width: 1280px) {
          .digital-charm-instruction {
            top: -15% !important;
            width: 40vw;
            font-size: 15px;
            padding: 10px 8px;
          }
          // .amulet-modal {
          //   padding: 24px 24px 42px !important;
            
          // }
          .amulet-modal-buttons {
            padding: ${modalShifted ? `5px` : `5px`} !important;
          }
        }
        @media (max-width: 1024px) {
          .amulet-modal-backdrop {
              padding-top: ${
                modalShifted ? `${TOP_OFFSET + 85}px` : `${TOP_OFFSET - 0}px`
              } !important;
            }
          .amulet-modal-buttons {
            padding: ${modalShifted ? `0px` : `0px`} !important;
          }
        }
        @media (max-width: 978px) {
          .digital-charm-instruction {
            top: 7.5%;
            width: 90vw;
            font-size: 15px;
            padding: 10px 8px;
          }
          .amulet-modal-backdrop {
            padding-top: ${
              modalShifted ? `${TOP_OFFSET + 85}px` : `${TOP_OFFSET - 60}px`
            } !important;
          }
          .amulet-modal-buttons {
            padding: ${modalShifted ? `5px` : `5px`} !important;
          }
          // .amulet-modal {
          //   padding: 24px 24px 42px;
          // }
        }
        @media (max-width: 768px) {
          .amulet-modal-backdrop {
              padding-top: ${
                modalShifted ? `${TOP_OFFSET + 85}px` : `${TOP_OFFSET - 0}px`
              } !important;
            }
          .amulet-modal-buttons {
            padding: ${modalShifted ? `0px` : `0px`} !important;
          }
        }
        @media (max-width: 600px) {
          .digital-charm-instruction {
            top: 15%;
            width: 90vw;
            font-size: 15px;
            padding: 10px 8px;
          }
          .amulet-modal-backdrop {
            padding-top: ${
              modalShifted ? `${TOP_OFFSET + 145}px` : `${TOP_OFFSET - 0}px`
            } !important;
          }
          .amulet-modal-buttons {
            padding: ${modalShifted ? `5px` : `5px`} !important;
          }
        }
        @media (min-width: 426px) and (max-width: 500px) {
          .amulet-modal-backdrop {
            padding-top: ${
              modalShifted ? `${TOP_OFFSET + 145}px` : `${TOP_OFFSET - 0}px`
            } !important;
          }
          .amulet-modal-buttons {
            padding: ${
              modalShifted ? `0px` : `${TOP_OFFSET - 60}px`
            } !important;
          }
        }
        @media (min-width: 401px) and (max-width: 425px) {
          .amulet-modal-backdrop {
            padding-top: ${
              modalShifted ? `${TOP_OFFSET + 170}px` : `${TOP_OFFSET - 0}px`
            } !important;
          }
          .amulet-modal-buttons {
            padding: ${
              modalShifted ? `0px` : `${TOP_OFFSET - 60}px`
            } !important;
          }
        }
        @media (min-width: 371px) and (max-width: 400px) {
          .amulet-modal-backdrop {
            padding-top: ${
              modalShifted ? `${TOP_OFFSET + 170}px` : `${TOP_OFFSET - 0}px`
            } !important;
          }
          .amulet-modal-buttons {
            padding: ${
              modalShifted ? `0px` : `${TOP_OFFSET - 60}px`
            } !important;
          }
        }
        @media (max-width: 370px) {
          .amulet-modal-backdrop {
            padding-top: ${
              modalShifted ? `${TOP_OFFSET + 180}px` : `${TOP_OFFSET - 0}px`
            } !important;
          }
          .amulet-modal-buttons {
            padding: ${
              modalShifted ? `${TOP_OFFSET - 70}px` : `${TOP_OFFSET - 70}px`
            } !important;
          }
        }
      `}
        </style>
      </div>
      {/* End wrapper */}
      {previewOpen &&
        modalPortalTarget &&
        createPortal(
          <div
            role="dialog"
            aria-modal="true"
            onClick={() => {
              setPreviewOpen(false);
              setModalShifted(false);
              setInstructionText("");
            }}
            className="amulet-modal-backdrop"
            style={{
              position: "fixed",
              inset: 0,
              width: "100vw",
              height: "100vh",
              overflowY: "auto",
              display: "flex",
              justifyContent: "center",
              alignItems: "flex-start",
              backgroundColor: "rgba(40, 40, 40, 0.7)",
              zIndex: 9999,
              cursor: "pointer",
              paddingTop: modalShifted
                ? `${TOP_OFFSET + (isMobile ? 240 : 130)}px`
                : `${TOP_OFFSET - 55}px`,
            }}
          >
            <div
              className="amulet-modal"
              style={{
                position: "relative",
                background: "transparent",
                borderRadius: 0,
                boxShadow: "0 8px 32px rgba(0,0,0,0.1)",
                width: `${540 * scale}px`,
                height: `${720 * scale}px`,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                cursor: "default",
                zIndex: 10000,
              }}
              onClick={(e) => e.stopPropagation()}
            >
              <div
                className="amulet-modal-buttons"
                style={{
                  position: "absolute",
                  bottom: 8,
                  left: "50%",
                  transform: "translateX(-50%)",
                  display: "flex",
                  gap: "24px",
                  zIndex: 20,
                  padding: modalShifted
                    ? window.innerWidth <= 1280
                      ? "12px 24px 52px"
                      : "12px 24px 2px"
                    : "24px 24px 2px",
                }}
              >
                <button
                  aria-label="Activate Now"
                  onClick={() => {
                    if (!instructionText) {
                      setInstructionText(
                        apiInstructionText || "No instructions available.",
                      );
                      setModalShifted(true);
                    } else {
                      setInstructionText("");
                      setModalShifted(false);
                    }
                  }}
                  style={{
                    background: "#000",
                    color: "#DFBD69",
                    border: "1px solid #DFBD69",
                    borderRadius: 16,
                    padding: "4px 10px",
                    fontSize: 14,
                    cursor: "pointer",
                    fontWeight: 600,
                    backdropFilter: "blur(3px)",
                  }}
                >
                  {instructionText
                    ? t("natalChart.hideInstruction")
                    : t("natalChart.activateNow")}
                </button>
                <button
                  aria-label="Close preview"
                  onClick={() => {
                    setPreviewOpen(false);
                    setModalShifted(false);
                    setInstructionText("");
                  }}
                  style={{
                    background: "#000",
                    color: "#DFBD69",
                    border: "1px solid #DFBD69",
                    borderRadius: 16,
                    padding: "4px 10px",
                    fontSize: 14,
                    cursor: "pointer",
                    fontWeight: 600,
                    backdropFilter: "blur(3px)",
                  }}
                >
                  {t("natalChart.close")} ✕
                </button>
              </div>
              <img
                src={previewImageUrl || fallbackCenterImage}
                alt="Charm Preview"
                style={{
                  width: "100%",
                  height: "100vh",
                  maxWidth: "100vw",
                  objectFit: "contain ",
                  borderRadius: 12,
                  display: "block",
                  boxShadow: "0 0 12px rgba(223,189,105,0.3)",
                  pointerEvents: "none",
                  userSelect: "none",
                }}
                onContextMenu={(e) => e.preventDefault()}
                draggable={false}
                onError={(e) => {
                  e.currentTarget.onerror = null;
                  e.currentTarget.src = fallbackCenterImage;
                }}
              />
              <div
                style={{
                  position: "absolute",
                  top: "6%",
                  left: "50%",
                  transform: "translate(-50%, 0)",
                  color: "#ffffff",
                  fontSize: "clamp(28px, 6vw, 64px)",
                  opacity: 0.12,
                  fontWeight: "700",
                  whiteSpace: "nowrap",
                  fontStyle: "italic",
                  textShadow: "2px 2px 6px #000",
                  pointerEvents: "none",
                  userSelect: "none",
                  maxWidth: "90%",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                {username}
              </div>
            </div>
          </div>,
          modalPortalTarget,
        )}
      {claimSuccessOpen &&
        modalPortalTarget &&
        createPortal(
          <div
            role="dialog"
            aria-modal="true"
            onClick={() => setClaimSuccessOpen(false)}
            style={{
              position: "fixed",
              inset: 0,
              backgroundColor: "rgba(40, 40, 40, 0.7)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              zIndex: 10002,
              padding: "20px",
            }}
          >
            <div
              onClick={(e) => e.stopPropagation()}
              style={{
                width: "100%",
                maxWidth: "420px",
                background: "#151515",
                border: "1px solid #DFBD69",
                borderRadius: "14px",
                boxShadow: "0 8px 24px rgba(0,0,0,0.35)",
                padding: "24px",
                textAlign: "center",
                color: "#DFBD69",
              }}
            >
              <p
                style={{
                  margin: "0 0 16px 0",
                  fontSize: "18px",
                  fontWeight: 600,
                  lineHeight: 1.4,
                }}
              >
                {t(
                  "natalChart.claimSuccessMessage",
                  "Thank you. You have collected your A-Mu",
                )}
              </p>
              <button
                onClick={() => {
                  setClaimSuccessOpen(false);
                  window.location.reload();
                }}
                style={{
                  background: "#000",
                  color: "#DFBD69",
                  border: "1px solid #DFBD69",
                  borderRadius: 10,
                  padding: "8px 14px",
                  fontSize: 14,
                  fontWeight: 600,
                  cursor: "pointer",
                }}
              >
                {t("fortuneStick.ok", "OK")}
              </button>
            </div>
          </div>,
          modalPortalTarget,
        )}
    </div>
  );
};

export default DigitalCharm;
